"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Container = _interopRequireDefault(require("@material-ui/core/Container"));
var _PageContext = _interopRequireDefault(require("@micado-digital/react-ui/context/PageContext"));
var _useIsLoggedIn = _interopRequireDefault(require("../../hooks/useIsLoggedIn"));
var _Menu = _interopRequireDefault(require("./Menu"));
var _MyAccount = _interopRequireDefault(require("./MyAccount01.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Addresses = (0, _component.default)(() => import("./Addresses"));
const Customer = (0, _component.default)(() => import("./Customer"));
const DigitalProducts = (0, _component.default)(() => import("./DigitalProducts"));
const DigitalProductDetails = (0, _component.default)(() => import("../../components/DigitalProductDetails"));
const Login = (0, _component.default)(() => import("../Login01"));
const OrderDetails = (0, _component.default)(() => import("./OrderDetails"));
const Orders = (0, _component.default)(() => import("./Orders"));
const Overview = (0, _component.default)(() => import("./Overview"));
const Preloader = (0, _component.default)(() => import("../../components/Preloader"));
const UserConnection = (0, _component.default)(() => import("@micado-digital/react-user-connection/ReactUserConnection"));
const MyAccount01 = _ref => {
  var _routeComponents$addr, _routeComponents$cust, _routeComponents$prod, _routeComponents$prod2, _routeComponents$orde, _routeComponents$orde2, _routeComponents$over;
  let {
    defaultLang = "de",
    menuComponent,
    productTeaserComponent,
    routeComponents
  } = _ref;
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const {
    lang: pageDataLang
  } = pageData || {};
  const [lang, setLang] = (0, _react.useState)(defaultLang);
  const [refetch, setRefetch] = (0, _react.useState)(new Date().getTime());
  const isLoggedIn = (0, _useIsLoggedIn.default)();
  const css = (0, _MyAccount.default)();
  (0, _react.useEffect)(() => {
    if (!pageDataLang) return;
    setLang(pageDataLang);
  }, [pageDataLang]);
  const handleConnectionChange = () => {
    setRefetch(new Date().getTime());
  };
  if (isLoggedIn === null) {
    return /*#__PURE__*/_react.default.createElement(Preloader, null);
  }
  if (!isLoggedIn) {
    return /*#__PURE__*/_react.default.createElement(Login, null);
  }
  return /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: (0, _clsx.default)(css.myAccount, "mco-shop-my-account"),
    maxWidth: "lg"
  }, menuComponent ? menuComponent : /*#__PURE__*/_react.default.createElement(_Menu.default, {
    lang: lang
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(UserConnection, {
    applicationType: "micadoshop",
    lang: lang,
    localStorageKey: "mco-shop-connection",
    onChange: handleConnectionChange
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, {
    key: refetch
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "addresses/*",
    element: (_routeComponents$addr = routeComponents === null || routeComponents === void 0 ? void 0 : routeComponents["addresses"]) !== null && _routeComponents$addr !== void 0 ? _routeComponents$addr : /*#__PURE__*/_react.default.createElement(Addresses, {
      lang: lang
    })
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "customer/*",
    element: (_routeComponents$cust = routeComponents === null || routeComponents === void 0 ? void 0 : routeComponents["customer"]) !== null && _routeComponents$cust !== void 0 ? _routeComponents$cust : /*#__PURE__*/_react.default.createElement(Customer, {
      lang: lang
    })
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "products/:productID",
    element: (_routeComponents$prod = routeComponents === null || routeComponents === void 0 ? void 0 : routeComponents["productDetails"]) !== null && _routeComponents$prod !== void 0 ? _routeComponents$prod : /*#__PURE__*/_react.default.createElement(DigitalProductDetails, {
      lang: lang
    })
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "products",
    element: (_routeComponents$prod2 = routeComponents === null || routeComponents === void 0 ? void 0 : routeComponents["products"]) !== null && _routeComponents$prod2 !== void 0 ? _routeComponents$prod2 : /*#__PURE__*/_react.default.createElement(DigitalProducts, {
      lang: lang,
      productTeaserComponent: productTeaserComponent
    })
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "orders/:id",
    element: (_routeComponents$orde = routeComponents === null || routeComponents === void 0 ? void 0 : routeComponents["orderDetails"]) !== null && _routeComponents$orde !== void 0 ? _routeComponents$orde : /*#__PURE__*/_react.default.createElement(OrderDetails, {
      lang: lang
    })
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "orders",
    element: (_routeComponents$orde2 = routeComponents === null || routeComponents === void 0 ? void 0 : routeComponents["orders"]) !== null && _routeComponents$orde2 !== void 0 ? _routeComponents$orde2 : /*#__PURE__*/_react.default.createElement(Orders, {
      lang: lang
    })
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    index: true,
    element: (_routeComponents$over = routeComponents === null || routeComponents === void 0 ? void 0 : routeComponents["overview"]) !== null && _routeComponents$over !== void 0 ? _routeComponents$over : /*#__PURE__*/_react.default.createElement(Overview, {
      lang: lang
    })
  }))));
};
MyAccount01.propTypes = {
  defaultLang: _propTypes.default.string,
  menuComponent: _propTypes.default.object,
  productTeaserComponent: _propTypes.default.object,
  routeComponents: _propTypes.default.object
};
var _default = exports.default = MyAccount01;